import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'

export class DocCommon {
  static HBL_History = {}
  static MBL_History = {}
  static MSC_History = {}
  static AMS_History = {}
  static AFR_History = {}
  static THAILAND_History = {}
  static NUM_CN = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '镹']
  static UNITS = ['', '拾', '百', '千', '万', '拾', '百', '千', '亿', '拾', '百', '千', '兆', '拾', '百', '千']

  static async newCargoDoc(model) {
    const cargoDoc = new SeaCargoDoc().fillDefaultValue().getData()
    cargoDoc.jobUuid = model.uuid
    await SeaCargoDoc.copyInfoFromSeaExportJob(model, cargoDoc)
    return cargoDoc
  }
  static newSeaImCargoDoc(model) {
    // var _cargoDoc: SeaImCargoDoc = new SeaImCargoDoc()
    // _cargoDoc.job = model
    // SeaImCargoDoc.copyInfoFromSeaImportJob(model, _cargoDoc)
    // return _cargoDoc
  }
  static toCNUpper(numStr) {
    // if (numStr.length == 0)
    //   return ""
    // var cnNum: String = ""
    // for (var i: int = numStr.length - 1 i >= 0 i--) {
    //   //	            	if ("0"!= numStr.charAt(i))
    //   cnNum = NUM_CN[parseInt(numStr.charAt(i))] + UNITS[numStr.length - 1 - i] + cnNum
    //   //				    else if ( i%4 == 0)
    //   //				    	cnNum =   UNITS[numStr.length-1 -i] + cnNum
    // }
    // return cnNum
  }
  static saveBillAddress(billAddress, cargoDoc, _obj) {
    // if (billAddress) {
    //   if (cargoDoc.docType == CargoDocConsts.HBL) {
    //     billAddress.partnerId = _obj.customerId
    //   } else if (cargoDoc.docType == CargoDocConsts.MBL) {
    //     if (_obj.destinationAgent > 0)
    //       billAddress.partnerId = _obj.destinationAgent
    //     else
    //       billAddress.partnerId = _obj.customerId
    //   } else {
    //     billAddress.partnerId = _obj.customerId
    //   }
    //   billAddress.pod = _obj.destinationPortCode
    //   billAddress.officeId = Session.getInstance().currentOffice.officeId
    //   billAddress.shipperCode = cargoDoc.shipperCode
    //   billAddress.shipperLine1 = cargoDoc.shipperLine1
    //   billAddress.shipperLine2 = cargoDoc.shipperLine2
    //   billAddress.shipperLine3 = cargoDoc.shipperLine3
    //   billAddress.shipperLine4 = cargoDoc.shipperLine4
    //   billAddress.shipperLine5 = cargoDoc.shipperLine5
    //   billAddress.shipperLine6 = cargoDoc.shipperLine6
    //   billAddress.consigneeCode = cargoDoc.consigneeCode
    //   billAddress.consigneeLine1 = cargoDoc.consigneeLine1
    //   billAddress.consigneeLine2 = cargoDoc.consigneeLine2
    //   billAddress.consigneeLine3 = cargoDoc.consigneeLine3
    //   billAddress.consigneeLine4 = cargoDoc.consigneeLine4
    //   billAddress.consigneeLine5 = cargoDoc.consigneeLine5
    //   billAddress.consigneeLine6 = cargoDoc.consigneeLine6
    //   billAddress.notifyCode = cargoDoc.notifyCode
    //   billAddress.notifyLine1 = cargoDoc.notifyLine1
    //   billAddress.notifyLine2 = cargoDoc.notifyLine2
    //   billAddress.notifyLine3 = cargoDoc.notifyLine3
    //   billAddress.notifyLine4 = cargoDoc.notifyLine4
    //   billAddress.notifyLine5 = cargoDoc.notifyLine5
    //   billAddress.notifyLine6 = cargoDoc.notifyLine6
    //   billAddress.lob = BillAddress.SE
    //   billAddress.lastUsed = new Date()
    //   billAddress.save2(requleHandler, failureHandler)
    // }
  }
  static requleHandler(result) {
    // FlexGlobals.topLevelApplication.status = ""
  }
  static failureHandler(event) {
    // FlexGlobals.topLevelApplication.status = "错误产生。"
  }
  /**
   * 默认创建拆单信息
   */
  static newSplitCargoDoc(model) {
    // var cargoDoc: SeaCargoDoc = model.getCargoDoc(CargoDocConsts.MBL2)
    // if (null == cargoDoc) {
    //   var _mblCargoDoc: SeaCargoDoc = model.getCargoDoc(CargoDocConsts.MBL)
    //   if (null == _mblCargoDoc) return
    //   cargoDoc = model.getCargoDoc(CargoDocConsts.MBL2, true)
    //   cargoDoc.shipperLine1 = _mblCargoDoc.shipperLine1
    //   cargoDoc.shipperLine2 = _mblCargoDoc.shipperLine2
    //   cargoDoc.shipperLine3 = _mblCargoDoc.shipperLine3
    //   cargoDoc.shipperLine4 = _mblCargoDoc.shipperLine4
    //   cargoDoc.shipperLine5 = _mblCargoDoc.shipperLine5
    //   cargoDoc.shipperLine6 = _mblCargoDoc.shipperLine6
    //   cargoDoc.shipperLine7 = _mblCargoDoc.shipperLine7
    //   cargoDoc.shipperCode = _mblCargoDoc.shipperCode
    //   cargoDoc.consigneeLine1 = _mblCargoDoc.consigneeLine1
    //   cargoDoc.consigneeLine2 = _mblCargoDoc.consigneeLine2
    //   cargoDoc.consigneeLine3 = _mblCargoDoc.consigneeLine3
    //   cargoDoc.consigneeLine4 = _mblCargoDoc.consigneeLine4
    //   cargoDoc.consigneeLine5 = _mblCargoDoc.consigneeLine5
    //   cargoDoc.consigneeLine6 = _mblCargoDoc.consigneeLine6
    //   cargoDoc.consigneeLine7 = _mblCargoDoc.consigneeLine7
    //   cargoDoc.consigneeCode = _mblCargoDoc.consigneeCode
    //   cargoDoc.notifyLine1 = _mblCargoDoc.notifyLine1
    //   cargoDoc.notifyLine2 = _mblCargoDoc.notifyLine2
    //   cargoDoc.notifyLine3 = _mblCargoDoc.notifyLine3
    //   cargoDoc.notifyLine4 = _mblCargoDoc.notifyLine4
    //   cargoDoc.notifyLine5 = _mblCargoDoc.notifyLine5
    //   cargoDoc.notifyLine6 = _mblCargoDoc.notifyLine6
    //   cargoDoc.notifyLine7 = _mblCargoDoc.notifyLine7
    //   cargoDoc.notifyCode = _mblCargoDoc.notifyCode
    //   cargoDoc.BLNumber = _mblCargoDoc.BLNumber
    //   cargoDoc.paymentPlaceBL = _mblCargoDoc.paymentPlaceBL
    //   cargoDoc.quantity = model.quantityActual
    //   cargoDoc.weight = model.weightActual
    //   cargoDoc.cubage = model.cubageActual
    //   cargoDoc.chargeWeight = model.chargeWeight
    //   cargoDoc.signPlaceBL = _mblCargoDoc.signPlaceBL
    //   cargoDoc.signDateBL = _mblCargoDoc.signDateBL
    //   //包装
    //   cargoDoc.packing = model.packing
    //   //英文品名
    //   cargoDoc.cargoEnglishName = model.cargoEnglishName
    //   //唛头
    //   cargoDoc.mark = model.mark
    //   cargoDoc.releaseType = _mblCargoDoc.releaseType
    //   //付款方式
    //   cargoDoc.paymentTerm = PaymentTerm.getPaymentTermNameByCode(model.paymentTermMBL)
    //   cargoDoc.docType = CargoDocConsts.MBL2
    //   //				if (model.typeMBL == BillType.MERGE_BILL_TYPE.code) {
    //   //					cargoDoc.soNo =  model.soNo
    //   //				} else {
    //   //					cargoDoc.soNo = model.soNo+"-1"
    //   //				}
    //   cargoDoc.mblNbr2 = model.mbl
    //   cargoDoc.hblNbr2 = cargoDoc.soNo
    //   cargoDoc.state = 1
    //   cargoDoc.containerSum = ContainerUtil.getSeaeqNumberStr(model)
    //   cargoDoc.quantitySum = StrUtils.getInstance().jsdx(cargoDoc.quantity, Packing.getPackingNameByCode(cargoDoc.packing))
    //   cargoDoc.seaeq = SeaExportUtils.getJoinSeaDocSeaEQDesc(cargoDoc, model, false, "Part of")
    //   cargoDoc.container = SeaExportUtils.getContainerQWCDesc(cargoDoc, false)
    // }
  }
  /**
   * 默认创建拆单信息
   */
  static newSplitSeaImCargoDoc(model) {
    // var cargoDoc: SeaImCargoDoc = model.getCargoDoc(CargoDocConsts.MBL2)
    // if (null == cargoDoc) {
    //   var _mblCargoDoc: SeaImCargoDoc = model.getCargoDoc(CargoDocConsts.MBL)
    //   if (null == _mblCargoDoc) return
    //   cargoDoc = model.getCargoDoc(CargoDocConsts.MBL2, true)
    //   cargoDoc.shipperLine1 = _mblCargoDoc.shipperLine1
    //   cargoDoc.shipperLine2 = _mblCargoDoc.shipperLine2
    //   cargoDoc.shipperLine3 = _mblCargoDoc.shipperLine3
    //   cargoDoc.shipperLine4 = _mblCargoDoc.shipperLine4
    //   cargoDoc.shipperLine5 = _mblCargoDoc.shipperLine5
    //   cargoDoc.shipperLine6 = _mblCargoDoc.shipperLine6
    //   cargoDoc.shipperLine7 = _mblCargoDoc.shipperLine7
    //   cargoDoc.shipperCode = _mblCargoDoc.shipperCode
    //   cargoDoc.consigneeLine1 = _mblCargoDoc.consigneeLine1
    //   cargoDoc.consigneeLine2 = _mblCargoDoc.consigneeLine2
    //   cargoDoc.consigneeLine3 = _mblCargoDoc.consigneeLine3
    //   cargoDoc.consigneeLine4 = _mblCargoDoc.consigneeLine4
    //   cargoDoc.consigneeLine5 = _mblCargoDoc.consigneeLine5
    //   cargoDoc.consigneeLine6 = _mblCargoDoc.consigneeLine6
    //   cargoDoc.consigneeLine7 = _mblCargoDoc.consigneeLine7
    //   cargoDoc.consigneeCode = _mblCargoDoc.consigneeCode
    //   cargoDoc.notifyLine1 = _mblCargoDoc.notifyLine1
    //   cargoDoc.notifyLine2 = _mblCargoDoc.notifyLine2
    //   cargoDoc.notifyLine3 = _mblCargoDoc.notifyLine3
    //   cargoDoc.notifyLine4 = _mblCargoDoc.notifyLine4
    //   cargoDoc.notifyLine5 = _mblCargoDoc.notifyLine5
    //   cargoDoc.notifyLine6 = _mblCargoDoc.notifyLine6
    //   cargoDoc.notifyLine7 = _mblCargoDoc.notifyLine7
    //   cargoDoc.notifyCode = _mblCargoDoc.notifyCode
    //   cargoDoc.BLNumber = _mblCargoDoc.BLNumber
    //   cargoDoc.paymentPlaceBL = _mblCargoDoc.paymentPlaceBL
    //   cargoDoc.quantity = model.quantityActual
    //   cargoDoc.weight = model.weightActual
    //   cargoDoc.cubage = model.cubageActual
    //   cargoDoc.chargeWeight = model.chargeWeight
    //   cargoDoc.signPlaceBL = _mblCargoDoc.signPlaceBL
    //   cargoDoc.signDateBL = _mblCargoDoc.signDateBL
    //   //包装
    //   cargoDoc.packing = model.packing
    //   //英文品名
    //   cargoDoc.cargoEnglishName = model.cargoEnglishName
    //   //唛头
    //   cargoDoc.mark = model.mark
    //   cargoDoc.releaseType = _mblCargoDoc.releaseType
    //   //付款方式
    //   cargoDoc.paymentTerm = PaymentTerm.getPaymentTermNameByCode(model.paymentTermMBL)
    //   cargoDoc.docType = CargoDocConsts.MBL2
    //   //				if (model.typeMBL == BillType.MERGE_BILL_TYPE.code) {
    //   //					cargoDoc.soNo =  model.soNo
    //   //				} else {
    //   //					cargoDoc.soNo = model.soNo+"-1"
    //   //				}
    //   cargoDoc.mblNbr2 = model.mbl
    //   //				cargoDoc.hblNbr2 = cargoDoc.soNo
    //   cargoDoc.state = 1
    //   cargoDoc.containerSum = ContainerUtil.getSeaeqNumberStr(model)
    //   cargoDoc.quantitySum = StrUtils.getInstance().jsdx(cargoDoc.quantity, Packing.getPackingNameByCode(cargoDoc.packing))
    //   //				cargoDoc.seaeq = SeaExportUtils.getJoinSeaDocSeaEQDesc(cargoDoc,model, false,"Part of")
    //   //				cargoDoc.container = SeaExportUtils.getContainerQWCDesc(cargoDoc,false)
    // }
  }
}
